export function isTelegramUserId(value: string): boolean {
    return /^\d+$/.test(value);
}
